import { API_URL } from '../Config.js';

const apiUrl = API_URL 


const getLeyendaList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetGrillaLeyenda`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

const addLeyenda = (data, accessToken) => {

    const url = `${apiUrl}formularios/FrmInsertLeyendaSoc`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });

}

const FrmUpdateLeyendaSoc = (data, accessToken) => {

    const url = `${apiUrl}formularios/FrmUpdateLeyendaSoc`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });

}



const FrmDelLeyendasSoc = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmDelLeyendasSoc` 

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { 
            return;
        })
        .catch(
            error => { 
                
            }); 

}

const getLeyendaPosicionList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetLeyendasPosicion`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};


export { getLeyendaList, getLeyendaPosicionList, addLeyenda, FrmUpdateLeyendaSoc, FrmDelLeyendasSoc }